import { render, staticRenderFns } from "./RequestsStatistics.vue?vue&type=template&id=e151fa42&scoped=true&"
import script from "./RequestsStatistics.vue?vue&type=script&lang=js&"
export * from "./RequestsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./RequestsStatistics.vue?vue&type=style&index=0&id=e151fa42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e151fa42",
  null
  
)

/* custom blocks */
import block0 from "./RequestsStatistics.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports